import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EmailAccount} from '../../entities/EmailAccount';
import {AppConfig} from '../../app.config';
import { Translation } from 'app/entities/Translation';

@Component({
  selector: 'app-login-view',
  templateUrl: './login-view.component.html',
  styleUrls: ['./login-view.component.css']
})
export class LoginViewComponent implements OnInit {

  languages: string[];
  translations: Map<string, Translation>;
  selectedLanguage: string;

  @Input()
  emailAccount: EmailAccount;

  @Input()
  loginError: string;

  
  @Input()
  loginInUser;
  
  @Input()
  companies;
  
  @Input()
  selectedCompany;
  
  @Input()
  isLoading;
  
  @Input('Languages')
  set Languages(language: string[]) {
    this.languages = language;
  }

  @Input('Translations')
  set Translations(translations: Map<string, Translation>) {
    this.translations = translations;
  }

  @Input('SelectedLanguage')
  set SelectedLanguage(selectedLanguage: string) {
    this.selectedLanguage = selectedLanguage;
  }

  
  
  @Output()
  private tryLoginEmitter = new EventEmitter();

  @Output()
  changeCompanyEmitter = new EventEmitter();

  @Output()
  LogInWithAdAccount = new EventEmitter()
  
  @Output()
  changeLanguageEmitter = new EventEmitter<string>()

  public hasMultipleCompanies: any;
  public siteTitle: string;

  constructor(private appConfig: AppConfig) {
    this.hasMultipleCompanies = this.appConfig.getConfig('hasMultipleCompanies');
    this.siteTitle = this.appConfig.getConfig('site.title');
  }

  ngOnInit() {

  }


  tryToLogin() {
    this.tryLoginEmitter.emit(this.emailAccount);
  }

  tryToLoginWithAdAccount() {
    this.LogInWithAdAccount.emit();
  }

  changeCompany(company) {
    this.changeCompanyEmitter.emit(company);
  }

  changeLanguage(language){
    this.changeLanguageEmitter.emit(language);
  }

  

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/login/login-view.component.ts